import { logStore } from "@/logging/logStore";

export default {
    async reset({ commit }) {
        commit('reset')
    },

    async set({ commit }, payload) {
        commit('set', payload)
    },

    async setEnabled({ commit }, enabled) {
        logStore.setDiagnosticMode(enabled)
        commit('set', { isEnabled: enabled })
    },

    async loadLogs({ commit }) {
        const logs = await logStore.getAllLogs()
        commit('setLogs', logs)
        return logs
    },

    async clearLogs({ commit }) {
        await logStore.clearLogs();
        commit('clearLogs')
    }
}
